import type { toast as baseToast } from "@/hooks/use-toast";

type ToastFn = typeof baseToast;

/** Destructive error toast: keeps the per-call title, extracts the error
 * message with a per-call fallback. Replaces the copy-pasted
 * `variant: "destructive"` + `error?.message || "…"` blocks. */
export const toastError = (
  toast: ToastFn,
  title: string,
  error?: unknown,
  fallback = "An error occurred."
) =>
  toast({
    variant: "destructive",
    title,
    description: (error as { message?: string } | undefined)?.message || fallback,
  });
